var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniversityAdmissionAvgfee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.555,
    height: 69.985,
    viewBox: "0 0 44.555 69.985",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48261",
    "data-name": "Group 48261",
    transform: "translate(-1580.13 -815.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48262",
    "data-name": "Group 48262",
    transform: "translate(1580.13 815.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48261-2",
    "data-name": "Group 48261",
    transform: "translate(0 44.553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55619",
    "data-name": "Path 55619",
    d: "M305.707,366.15H267.512a3.179,3.179,0,1,1,0-6.358h38.194a3.179,3.179,0,0,1,0,6.358Z",
    transform: "translate(-264.331 -359.792)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55620",
    "data-name": "Path 55620",
    d: "M271.219,363.5h37.624a3.214,3.214,0,0,0,.044-.527,3.179,3.179,0,0,0-3.179-3.179H267.512a3.179,3.179,0,1,0,0,6.358h.571A3.18,3.18,0,0,1,271.219,363.5Z",
    transform: "translate(-264.331 -359.792)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55621",
    "data-name": "Path 55621",
    d: "M305.707,401.5H267.512a3.179,3.179,0,0,1,0-6.358h38.194a3.179,3.179,0,0,1,0,6.358Z",
    transform: "translate(-264.331 -388.779)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55622",
    "data-name": "Path 55622",
    d: "M271.219,398.843h37.624a3.213,3.213,0,0,0,.044-.527,3.179,3.179,0,0,0-3.179-3.179H267.512a3.179,3.179,0,0,0,0,6.358h.571A3.18,3.18,0,0,1,271.219,398.843Z",
    transform: "translate(-264.331 -388.779)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55623",
    "data-name": "Path 55623",
    d: "M305.695,472.181H267.5a3.179,3.179,0,1,1,0-6.358h38.194a3.179,3.179,0,0,1,0,6.358Z",
    transform: "translate(-264.321 -446.749)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55624",
    "data-name": "Path 55624",
    d: "M271.207,469.53H308.83a3.182,3.182,0,0,0-3.136-3.706H267.5a3.179,3.179,0,0,0,0,6.358h.571A3.18,3.18,0,0,1,271.207,469.53Z",
    transform: "translate(-264.321 -446.75)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55625",
    "data-name": "Path 55625",
    d: "M305.695,436.839H267.5a3.179,3.179,0,1,1,0-6.358h38.194a3.179,3.179,0,0,1,0,6.358Z",
    transform: "translate(-264.321 -417.765)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55626",
    "data-name": "Path 55626",
    d: "M271.207,434.187H308.83a3.182,3.182,0,0,0-3.136-3.706H267.5a3.179,3.179,0,0,0,0,6.358h.571A3.18,3.18,0,0,1,271.207,434.187Z",
    transform: "translate(-264.321 -417.764)",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2838",
    "data-name": "Ellipse 2838",
    cx: 22.276,
    cy: 22.276,
    r: 22.276,
    transform: "translate(0.002)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55632",
    "data-name": "Path 55632",
    d: "M268.034,134.408a22.278,22.278,0,0,1,20.423-22.2q-.917-.076-1.853-.076a22.276,22.276,0,0,0,0,44.552q.936,0,1.853-.076A22.278,22.278,0,0,1,268.034,134.408Z",
    transform: "translate(-264.326 -112.132)",
    fill: "#387f75"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_55633",
    "data-name": "Path 55633",
    d: "M350.926,167.476a5.56,5.56,0,0,0,5.554,5.554h2.287a2.774,2.774,0,0,1,0,5.548h-2.58a2.358,2.358,0,0,1-2.272-1.691,1.39,1.39,0,0,0-2.663.8,5.12,5.12,0,0,0,4.935,3.672h.046v3a1.39,1.39,0,0,0,2.78,0v-3.007a5.554,5.554,0,0,0-.246-11.1H356.48a2.774,2.774,0,0,1,0-5.548h2.044a2.358,2.358,0,0,1,2.272,1.691,1.39,1.39,0,1,0,2.663-.8,5.116,5.116,0,0,0-4.445-3.649v-3.024a1.39,1.39,0,0,0-2.78,0v3.007A5.561,5.561,0,0,0,350.926,167.476Z",
    transform: "translate(1246.547 665.97)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityAdmissionAvgfee);
export default __webpack_public_path__ + "static/media/university-admission-avgfee.dbc4124839767a514e68d69ff1f31e45.svg";
export { ForwardRef as ReactComponent };